import React from "react";
import Overlay from "../overlay/Overlay";
import { Box } from "@mui/material";
import TimerOptionItem from "./TimerOptionItem";
import { setHomeDrawingGivenTime } from "../../state/actions";
import { connect } from "react-redux";

export const UNLIMITED_TIMER_MAX = 99999999999999;
interface TimerOptionsProps {
  closeOverlay: () => void;
}
const TimerOptions: React.FC<TimerOptionsProps & any> = ({
  closeOverlay,
  setHomeDrawingGivenTime
}) => {

  const setTimeLimit = (time: number) => {
    setHomeDrawingGivenTime(time)
    closeOverlay();
  }
  return (
    <div>
      <Overlay closeOverlay={closeOverlay}>
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexWrap: "wrap",
            margin: "auto",
            gap: "20px",
            justifyContent: "center",
          }}
        >
          <TimerOptionItem
            number={10}
            timeUnit="seconds"
            setTimeLimit={() => setTimeLimit(10)}
          />
          <TimerOptionItem
            number={20}
            timeUnit="seconds"
            setTimeLimit={() => setTimeLimit(20)}
          />
          <TimerOptionItem
            number={30}
            timeUnit="seconds"
            setTimeLimit={() => setTimeLimit(30)}
          />
          <TimerOptionItem
            number={1}
            timeUnit="minute"
            setTimeLimit={() => setTimeLimit(60)}
          />
          <TimerOptionItem
            number={2}
            timeUnit="minutes"
            setTimeLimit={() => setTimeLimit(120)}
          />
          <TimerOptionItem
            number={3}
            timeUnit="minutes"
            setTimeLimit={() => setTimeLimit(180)}
          />
          <TimerOptionItem
            unlimited={true}
            setTimeLimit={() => setTimeLimit(UNLIMITED_TIMER_MAX)}
          />
        </Box>
      </Overlay>
    </div>
  );
};


const mapStateToProps = (state: any) => {
  const {
    homeDrawingGivenTime
  } = state;
  return {
    homeDrawingGivenTime

  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    setHomeDrawingGivenTime: (payload: any) => dispatch(setHomeDrawingGivenTime(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TimerOptions);

